import * as actions from 'app/actions/marketing';
import * as client from './contentful-client';

const fetchMarketingPage = slug => ({
  promise: () => client.getStandalonePageBySlug(slug),
  events: ['PROMISE_PENDING', actions.SET_MARKETING_PAGE, 'PROMISE_ERROR'],
});

export default fetchMarketingPage;



// WEBPACK FOOTER //
// ./app/api/marketing-api.js